import { VehicleOfferDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle-b";
import { useCallback, useEffect, useState } from "react";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { offerResolverSelector } from "@/domains/offer/slice";

export default function useOfferResolverVehicle(isShow: boolean) {
  const [vehicle, setVehicle] = useState<VehicleOfferDto | null>(null);
  const [pending, setPending] = useState<boolean>(false);
  const offerResolver = useAppSelector(offerResolverSelector);

  const load = useCallback(async () => {
    if (!offerResolver) {
      return;
    }

    try {
      setVehicle(null);
      setPending(true);
      const response = await VehicleMpProvider.getVehicleOfferResolver(offerResolver.targetId);

      if (response instanceof RpcMpProviderFailedResponse) {
        console.error("Failed to fetch vehicleBuyInfo", response);
        return;
      }

      setVehicle(response.data);
    } catch (error) {
      console.error("vehicleBuyInfo fetch error:", error);
    } finally {
      setPending(false);
    }
  }, [offerResolver]);

  useEffect(() => {
    if (isShow) {
      load();
    }
  }, [isShow, load]);

  return {
    vehicle,
    pending,
  };
}
